/* ==========================================================================
   Reviews Carousel — oddit-section-reviews-carousel
   Handles scroll-based progress bar updates
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-reviews-carousel';
  var TRACK_SELECTOR = '.oddit-section-reviews-carousel__track';
  var INDICATOR_SELECTOR = '.oddit-section-reviews-carousel__progress-indicator';

  function initSection(section) {
    var track = section.querySelector(TRACK_SELECTOR);
    var indicator = section.querySelector(INDICATOR_SELECTOR);
    if (!track || !indicator) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      indicator.style.left = '0';
      if (maxScroll <= 0) {
        indicator.style.width = '100%';
        return;
      }
      var cards = track.querySelectorAll('.oddit-section-reviews-carousel__card');
      var totalCards = cards.length;
      if (totalCards === 0) {
        indicator.style.width = '0';
        return;
      }
      var cardWidth = cards[0].offsetWidth;
      var gapStr = getComputedStyle(track).gap || getComputedStyle(track).columnGap || '0';
      var gap = parseInt(gapStr, 10) || 0;
      var visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));
      var baseWidth = Math.min(1, visibleCards / totalCards);
      var scrollRatio = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
      var widthRatio = baseWidth + scrollRatio * (1 - baseWidth);
      indicator.style.width = (widthRatio * 100) + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });

    /* Initial update after layout */
    requestAnimationFrame(function () {
      requestAnimationFrame(updateProgress);
    });

    /* Recalculate on resize */
    var ro = new ResizeObserver(function () {
      updateProgress();
    });
    ro.observe(track);

    /* ---- Autoplay ---- */
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseFloat(section.dataset.autoplaySpeed);
    if (!autoplaySpeed || autoplaySpeed <= 0) autoplaySpeed = 5;
    var reducedMotionMQ = null;
    try { reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)'); } catch (e) {}
    var autoplayTimer = null;
    var paused = false;

    function reducedMotionActive() {
      return !!(reducedMotionMQ && reducedMotionMQ.matches);
    }

    function getCardStep() {
      var cards = track.querySelectorAll('.oddit-section-reviews-carousel__card');
      if (cards.length === 0) return 0;
      var gapStr = getComputedStyle(track).gap || getComputedStyle(track).columnGap || '0';
      var gap = parseInt(gapStr, 10) || 0;
      return cards[0].offsetWidth + gap;
    }

    function advance() {
      if (paused) return;
      var step = getCardStep();
      if (step <= 0) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;
      var target;
      if (track.scrollLeft + step > maxScroll - 1) {
        target = 0;
      } else {
        target = track.scrollLeft + step;
      }
      try {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } catch (e) {
        track.scrollLeft = target;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || reducedMotionActive() || paused) return;
      stopAutoplay();
      autoplayTimer = setInterval(advance, autoplaySpeed * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function pause() {
      paused = true;
      stopAutoplay();
    }

    function resume() {
      paused = false;
      startAutoplay();
    }

    if (autoplayEnabled) {
      section.addEventListener('mouseenter', pause);
      section.addEventListener('mouseleave', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('focusin', pause);
      track.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else if (!paused) startAutoplay();
      });
      if (reducedMotionMQ) {
        try {
          reducedMotionMQ.addEventListener('change', function () {
            if (reducedMotionActive()) stopAutoplay();
            else startAutoplay();
          });
        } catch (e) {
          if (typeof reducedMotionMQ.addListener === 'function') {
            reducedMotionMQ.addListener(function () {
              if (reducedMotionActive()) stopAutoplay();
              else startAutoplay();
            });
          }
        }
      }
      startAutoplay();
    }

    /* Store cleanup references */
    section._reviewsCarouselCleanup = function () {
      track.removeEventListener('scroll', updateProgress);
      ro.disconnect();
      stopAutoplay();
    };
  }

  function destroySection(section) {
    if (section._reviewsCarouselCleanup) {
      section._reviewsCarouselCleanup();
      delete section._reviewsCarouselCleanup;
    }
  }

  /* Init all instances on page */
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();